/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MassTransitCommonSupportServiceAttachmentDataFromJSON, MassTransitCommonSupportServiceAttachmentDataToJSON, } from './MassTransitCommonSupportServiceAttachmentData';
/**
 * Check if a given object implements the MassTransitCommonSupportServiceMessageData interface.
 */
export function instanceOfMassTransitCommonSupportServiceMessageData(value) {
    return true;
}
export function MassTransitCommonSupportServiceMessageDataFromJSON(json) {
    return MassTransitCommonSupportServiceMessageDataFromJSONTyped(json, false);
}
export function MassTransitCommonSupportServiceMessageDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Name': json['Name'] == null ? undefined : json['Name'],
        'DeviceUid': json['DeviceUid'] == null ? undefined : json['DeviceUid'],
        'Body': json['Body'] == null ? undefined : json['Body'],
        'Subject': json['Subject'] == null ? undefined : json['Subject'],
        'Attachment': json['Attachment'] == null ? undefined : json['Attachment'],
        'Email': json['Email'] == null ? undefined : json['Email'],
        'AttachmentData': json['AttachmentData'] == null ? undefined : (json['AttachmentData'].map(MassTransitCommonSupportServiceAttachmentDataFromJSON)),
    };
}
export function MassTransitCommonSupportServiceMessageDataToJSON(json) {
    return MassTransitCommonSupportServiceMessageDataToJSONTyped(json, false);
}
export function MassTransitCommonSupportServiceMessageDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Name': value['Name'],
        'DeviceUid': value['DeviceUid'],
        'Body': value['Body'],
        'Subject': value['Subject'],
        'Attachment': value['Attachment'],
        'Email': value['Email'],
        'AttachmentData': value['AttachmentData'] == null ? undefined : (value['AttachmentData'].map(MassTransitCommonSupportServiceAttachmentDataToJSON)),
    };
}
//# sourceMappingURL=MassTransitCommonSupportServiceMessageData.js.map